import React from "react";
import { Badge } from "@shadcn-in-nx/ui/badge";
import {
    Play,
    CheckCircle,
    XCircle,
    Clock,
    AlertCircle,
} from "lucide-react";
import { useTranslation } from "react-i18next";

const STATUS_CONFIG = {
    completed: {
        className: "bg-green-100 text-green-800 border-green-200 hover:bg-green-100",
        Icon: CheckCircle,
        key: "monitoring.status.completed",
    },
    failed: {
        className: "bg-red-100 text-red-800 border-red-200 hover:bg-red-100",
        Icon: XCircle,
        key: "monitoring.status.failed",
    },
    running: {
        className: "bg-blue-100 text-blue-800 border-blue-200 hover:bg-blue-100",
        Icon: Play,
        key: "monitoring.status.running",
    },
    pending_finish: {
        className: "bg-orange-100 text-orange-800 border-orange-200 hover:bg-orange-100",
        Icon: AlertCircle,
        key: "monitoring.status.pendingFinish",
    },
    pending: {
        className: "bg-yellow-100 text-yellow-800 border-yellow-200 hover:bg-yellow-100",
        Icon: Clock,
        key: "monitoring.status.pending",
    },
};

function StatusBadge({ status }) {
    const { t } = useTranslation();
    const config = STATUS_CONFIG[status];

    if (!config) {
        return (
            <Badge variant="outline">
                <Clock className="h-3 w-3 mr-1" />
                {status}
            </Badge>
        );
    }

    const { className, Icon, key } = config;
    return (
        <Badge className={className}>
            <Icon className="h-3 w-3 mr-1" />
            {t(key)}
        </Badge>
    );
}

export default StatusBadge;
